module.exports = __webpack_public_path__ + "static/img/guide-29.1889e56c.png";